export { default } from './Accordion';
export { default as accordionClasses } from './accordionClasses';
export * from './accordionClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Accordion/index.js
// module id = 872
// module chunks = 25